import qq from '../js/lib/jquery.file-uploader.min.js'
import { MainApp } from './zarf/app.main.js'
import 'eonasdan-bootstrap-datetimepicker'

import basicLightbox from 'basiclightbox'

window.bl = basicLightbox
window.qq = qq

// import 'tag-it';
// import '@fancyapps/fancybox';

// import 'jquery-ui/ui/widgets/sortable';
// import 'jquery-ui/ui/widgets/tooltip';
// import 'jquery-ui/ui/widgets/datepicker';
// import 'jquery-ui/ui/widgets/autocomplete';

window.MainApp = MainApp
